import * as ticketService from './service/ticket.service';

const state = {
    ticket: null,
    tickets: [],
    ticketsPagination: {
        page: 1,
        limit: 10,
        totalItems: 0,
        totalPages: 0,
    },
    deletedTickets: [],
    deletedTicketsPagination: {
        page: 1,
        limit: 10,
        totalItems: 0,
        totalPages: 0,
    },
    //
    unqualified: false,
    //
    allTickets: [],
    loadingTicket: false,
    filtersTicket: {
        ticket_number: null,
        status: null,
        area: null
    }
};

const mutations = {
    SET_FILTER_TICKET(state, data) {
        state.filtersTicket = data;
    },

    SET_LOADING_TICKET(state, data) {
        state.loadingTicket = data;
    },

    SET_TICKET(state, ticket) {
        state.ticket = ticket;
    },

    SET_ALL_TICKETS(state, data) {
        state.allTickets = data;
    },

    SET_TICKETS(state, payload) {
        state.tickets = payload;
    },

    SET_TICKET_PAGINATION(state, payload) {
        state.ticketsPagination = { ...state.ticketsPagination, ...payload };
    },

    SET_PAGE(state, page) {
        state.tickets.page = page;
    },

    SET_LIMIT(state, limit) {
        state.tickets.limit = limit;
    },

    SET_DELETED_TICKETS(state, payload) {
        state.deletedTickets = payload;
    },

    SET_DELETED_TICKET_PAGINATION(state, payload) {
        state.deletedTicketsPagination = { ...state.deletedTicketsPagination, ...payload };
    },

    SET_UNQUALIFIED(state, value) {
        state.unqualified = value;
    },
    // UPDATE_TICKET(state, updateTicket) {
    //     const index = state.tickets.findIndex((ticket) => ticket.id === updateTicket.id);
    //     if (index !== -1) {
    //         state.tickets.splice(index, 1, updateTicket);
    //     }
    // },

    // DELETE_TICKET(state, ticketId) {
    //     const index = state.tickets.findIndex((ticket) => ticket.id === ticketId);
    //     if (index !== -1) {
    //         state.tickets.splice(index, 1);
    //     }
    // },
};

const actions = {

    async exportTicketsReport(__, params = {}) {
        try {
            await ticketService.exportTicketsReport(params);
            return { ok: true };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error al exportar el reporte de tickets' };
        }
    },

    async reclassifyTicket(__, { ticketId, subtypeId, assigned_user_id }) {
        try {
            const response = await ticketService.reclassifyTicket(ticketId, { subtype_id: subtypeId, assigned_user_id : assigned_user_id });
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error al reclasificar el ticket' };
        }
    },

    async changeCompany(__, { ticketId, companyId }) {
        try {
            const response = await ticketService.changeCompany(ticketId, { company_id: companyId });
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error al cambiar la compañía del ticket' };
        }
    },

    async exportSummaryTicketsReport() {
        try {
            await ticketService.exportSummaryTicketsReport();
            return { ok: true };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error al exportar el reporte de resumen de atención de tickets' };
        }
    },
    
    async createTicket(__, data) {
        try {
            const response = await ticketService.saveTicket(data);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async confirmUser(__, data) {
        try {
            const response = await ticketService.addUserConfirm(data);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async addUser(__, data) {
        try {
            const response = await ticketService.addUserTicket(data);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async getTicketById({ commit }, id) {
        try {
            const response = await ticketService.getTicketById(id);
            commit('SET_TICKET', response);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async sendTicketCloseNotificationMail(__, id) {
        try {
            const response = await ticketService.sendTicketCloseNotification(id);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async listAllTickets(__, data) {
        try {
            const response = await ticketService.getTicket(data);
            // commit('SET_ALL_TICKETS', response.tickets);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async listTicket({ commit }, data) {
        try {
            commit('SET_TICKETS', []);
            const response = await ticketService.getTicket(data);

            //
            commit('SET_UNQUALIFIED', response?.unqualified || false);
            //
            const pagination = {
                page: response?.ticketsPagination.page,
                limit: response?.ticketsPagination.limit,
                totalItems: response?.ticketsPagination.totalItems,
                totalPages: response?.ticketsPagination.totalPages,
            };
            commit('SET_TICKETS', response?.tickets || []);
            commit('SET_TICKET_PAGINATION', pagination || {});
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async listTicketForUsers({ commit }, data) {
        try {
            commit('SET_TICKETS', []);
            const response = await ticketService.getTicketsForUsers(data);
            const pagination = {
                page: response?.ticketsPagination.page,
                limit: response?.ticketsPagination.limit,
                totalItems: response?.ticketsPagination.totalItems,
                totalPages: response?.ticketsPagination.totalPages,
            };
            commit('SET_UNQUALIFIED', response?.unqualified || false);
            commit('SET_TICKETS', response?.tickets || []);
            commit('SET_TICKET_PAGINATION', pagination || {});
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async listDeletedTicketForResponsibles({ commit }, data) {
        try {
            commit('SET_DELETED_TICKETS', []);
            const response = await ticketService.getDeletedTicketsForResponsibles(data);
            const pagination = {
                page: response?.ticketsPagination.page,
                limit: response?.ticketsPagination.limit,
                totalItems: response?.ticketsPagination.totalItems,
                totalPages: response?.ticketsPagination.totalPages,
            };
            commit('SET_DELETED_TICKETS', response?.tickets || []);
            commit('SET_DELETED_TICKET_PAGINATION', pagination || {});
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async listTicketForResponsibles({ commit }, data) {
        try {
            commit('SET_TICKETS', []);
            const response = await ticketService.getTicketsForResponsibles(data);
            const pagination = {
                page: response?.ticketsPagination.page,
                limit: response?.ticketsPagination.limit,
                totalItems: response?.ticketsPagination.totalItems,
                totalPages: response?.ticketsPagination.totalPages,
            };
            commit('SET_UNQUALIFIED', response?.unqualified || false);
            commit('SET_TICKETS', response?.tickets || []);
            commit('SET_TICKET_PAGINATION', pagination || {});
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async closeTicket({ commit }, id) {
        try {
            const response = await ticketService.closeTicket(id);
            commit('SET_TICKET', response);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async ticketConfirm({ commit }, id) {
        try {
         
            const response = await ticketService.confirmTicket(id);
          
            commit('SET_TICKET', response);
            return { ok: true, response };
        } catch (error) {
         
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async reassignResponsible(__, { id, data }) {
        try {
            const response = await ticketService.reassignResponsible(id, data);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },

    async deleteTicket(__, { id, company_id }) {
        try {
            const response = await ticketService.deleteTicket(id, { company_id });
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error al eliminar el ticket' };
        }
    },

    async declinedTicket(__, {id, data}) {
        try {
            console.log(id)
            console.log(data)
            const response = await ticketService.declineTicket(id,data);
            return { ok: true, response };
        } catch (error) {
            return { ok: false, error: error?.response || 'Error en el servicio' };
        }
    },


    cleanTicket({ commit }) {
        commit('SET_TICKET', null);
    },

    cleanTickets({ commit }) {
        commit('SET_TICKETS', []);
        commit('SET_TICKET_PAGINATION', {
            page: 0,
            limit: 0,
            totalItems: 0,
            totalPages: 0,
        });
    },

    cleanDeletedTickets({ commit }) {
        commit('SET_DELETED_TICKETS', []);
        commit('SET_DELETED_TICKET_PAGINATION', {
            page: 0,
            limit: 0,
            totalItems: 0,
            totalPages: 0,
        });
    },
};

const getters = {
    getSubtypeParents: (state) => (subtypeId) => {
        const subtypes = state.ticket.subtype.classification.subtypes;
        const map = new Map(subtypes.map(s => [s.id, s]));

        const parents = [];

        let currentChild = map.get(subtypeId);
        while (currentChild) {
        parents.unshift(currentChild); // inserta al inicio para ordenar de raíz a hijo
        if (!currentChild.parent_subtype_id) break;
        currentChild = map.get(currentChild.parent_subtype_id);
        }

        return parents;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};